import * as React from "react"
import Dialog from "@mui/material/Dialog"
import DialogActions from "@mui/material/DialogActions"
import DialogContent from "@mui/material/DialogContent"
import DialogTitle from "@mui/material/DialogTitle"
import { IconButton, InputAdornment, TextField } from "@mui/material"
import CloseIcon from '@mui/icons-material/Close';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney'
import Grid from "@mui/material/Grid2"
import { Button } from "@mui/material"
import { LoadingBackdropIndeterminate } from "../../LoadingBackdrop"
import { useSnackbar } from "notistack"
import { send_authorized_request } from "../../../Constants/cognito"
import { AXIOS_API_INSTANCE } from "../../../Constants"
import { changePaymentAmount } from "./PaymentModalFunctions"

export default function ManualPaymentEditModal({
    open,
    closeModal,
    invoice,
    invoicePayment
}) {
    const { enqueueSnackbar } = useSnackbar();
    const [paymentAmount, setPaymentAmount] = React.useState(0)
    const [checkoutPayingStep, setCheckoutPayingStep] = React.useState(0)
    const [description, setDescription] = React.useState('')
    const mychangePaymentAmount = changePaymentAmount(setPaymentAmount, Infinity)

    const submit = (e) => {
        e.preventDefault();
        setCheckoutPayingStep(1)
        const payment_object = {
            payment_amount: paymentAmount,
            description: description,
        }
        send_authorized_request(() =>
            AXIOS_API_INSTANCE.post(`invoicepayments/${invoicePayment.id}/manual_edit`, payment_object).then(() => {
                setCheckoutPayingStep(0)
                enqueueSnackbar('Successfully updated payment', { variant: 'success' })
                closeModal(true)
            }).catch((error) => {
                setCheckoutPayingStep(0)
                enqueueSnackbar(`Failed to update payment <${error.response?.data?.message ?? "Unknown Error Occurred"}>`, { variant: 'error' })
            })
        )
    }

    React.useEffect(() => {
        if (open) {
            setPaymentAmount(invoicePayment?.total_cost ?? 0)
            setDescription(invoicePayment?.payment_data?.[0]?.description ?? '')
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [open])

    return (
        (<div>
            <Dialog
                open={open}
                onClose={() => closeModal(false)}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
                maxWidth='xs'
                fullWidth
            >
                <LoadingBackdropIndeterminate
                    open={checkoutPayingStep > 0}
                    text={"Submitting Payment"}
                />
                <form onSubmit={submit}>
                    <DialogTitle>
                        <span style={{ "paddingRight": "24px" }}>Edit Manual Payment</span>
                        <IconButton
                            aria-label="close"
                            onClick={() => closeModal(false)}
                            sx={{
                                position: 'absolute',
                                right: 8,
                                top: 8
                            }}
                        >
                            <CloseIcon />
                        </IconButton>
                    </DialogTitle>
                    <DialogContent>
                        <Grid container direction="column" spacing={2}>
                            <Grid item>
                                <TextField
                                    margin="dense"
                                    id="paymentamount"
                                    label="Payment Amount"
                                    type="number"
                                    fullWidth
                                    variant="standard"
                                    value={paymentAmount.toString()}
                                    onChange={mychangePaymentAmount}
                                    sx={{ minWidth: '125px' }}
                                    slotProps={{
                                        input: {
                                            // inputProps: { min: Math.min(0, Math.round(amount * 100) / 100), max: Math.max(0, Math.round(amount * 100) / 100), step: "any" },
                                            startAdornment: (
                                                <InputAdornment position="start">
                                                    {<AttachMoneyIcon />}
                                                </InputAdornment>
                                            ),
                                        }
                                    }}
                                />
                            </Grid>
                            <Grid item>
                                <TextField
                                    margin="dense"
                                    id="input"
                                    label="Reason for Manual Payment"
                                    type="text"
                                    fullWidth
                                    variant="filled"
                                    value={description}
                                    onChange={(e) => setDescription(e.target.value)}
                                />
                            </Grid>
                        </Grid>
                    </DialogContent>
                    <DialogActions>
                        <Grid container justifyContent="space-between" sx={{ padding: "0px 30px 10px 30px", width: '100%' }}>
                            <Grid xs="auto">
                            </Grid>
                            <Grid xs="auto">
                                <Button variant="contained" type="submit">
                                    Submit
                                </Button>
                            </Grid>
                        </Grid>
                    </DialogActions>
                </form>
            </Dialog>
        </div>)
    );
}
